import { Link } from "react-router";

export function Brand() {
  return (
    <Link className="brand" to="/" aria-label="StudyCoach 首页">
      <img src="/brand/studycoach.svg" alt="" />
      <span>
        <strong>StudyCoach</strong>
        <small>把资料学成能力</small>
      </span>
    </Link>
  );
}
